export function createCampaignStepPieceIndexesMap(pieces) {
  return (pieces || []).reduce((indexesMap, piece, index) => {
    if (piece && piece.id) {
      indexesMap[piece.id] = index;
    }
    return indexesMap;
  }, {});
}
